import cx from 'classnames';

import {Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {ProgressTrackerProps} from './HorizontalProgressTracker.types';

import * as css from './HorizontalProgressTracker.css';

export const HorizontalProgressTracker = ({
  className,
  items,
  currentItemIndex: _currentItemIndex,
  currentItemStatus,
}: ProgressTrackerProps) => {
  const currentItemIndex = Math.min(Math.max(_currentItemIndex || 0, -1), items.length - 1);

  return (
    <div className={sprinkles({flex: 'flex', dir: 'col'})}>
      <div
        className={cx(sprinkles({flex: 'flex', dir: 'row'}), className, css.textPlacementCenter)}>
        {items.map((_, index) => {
          let status: css.ItemStatus = 'incomplete';
          if (currentItemIndex > index) {
            status = 'completed';
          } else if (currentItemIndex === index) {
            status = currentItemStatus === 'completed' ? 'completed' : 'inProgress';
          }
          return (
            <div className={sprinkles({flex: 'flex', dir: 'col', grow: 1})} key={index}>
              <div
                className={css.itemTrack({first: index === 0, last: index === items.length - 1})}>
                <Text
                  as="div"
                  fontWeight="semiBold"
                  className={css.itemMarker({
                    status,
                    isFirst: index === 0,
                    isSecond: index === 1,
                    isThird: index === 2,
                    isFourth: index === 3,
                    isLast: index === items.length - 1,
                  })}>
                  &nbsp;
                </Text>
                {index < items.length - 1 && (
                  <div
                    className={css.itemLine({
                      isCompleted: status === 'completed',
                      inProgress: status === 'inProgress',
                      firstLine: index === 0,
                      secondLine: index === 1,
                      thirdLine: index === 2,
                      fourthLine: index === 3,
                    })}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
      <ol className={sprinkles({flex: 'flex', dir: 'row', placeContent: 'between'})}>
        {items.map(({title, subtitle}, i) => (
          <li key={i} className={sprinkles({flex: 'flex', dir: 'col', gap: 20})}>
            <Text
              className={css.itemStep}
              color={status !== 'incomplete' ? 'doveGray' : 'dustyGray'}
              fontWeight="semiBold"
              textAlign="center">
              {title}
            </Text>
            {subtitle && (
              <Text color="dustyGray" textAlign="center" variant="caption">
                {subtitle}
              </Text>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};
